import type { BrandKey } from '@jotta/config/brand'
import { getBrandAlias } from '@jotta/config/brand'
import config from '@jotta/config/BrandConfig'
import Debug from 'debug'
import { objectKeys } from '@jotta/types/TypeUtils'
const debug = Debug('jotta:branding:setBodyTheme')

export function setBodyThemeClassName(brand: BrandKey) {
  const id = getBrandAlias(brand)
  debug('Set theme: %s', id)
  document.documentElement.dataset.theme = id
  const cls = document.body.classList
  if (cls.contains(id)) {
    return
  }
  cls.add(id)
  cls.remove(
    ...objectKeys(config)
      .map(getBrandAlias)
      .filter(item => item !== id),
  )
}
